(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('defaultSrc', ["$parse", "$timeout", function ($parse, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            link: function ($scope, element, attrs) {
                var defaultSrc = $parse(attrs.defaultSrc)($scope);
                if (_(defaultSrc).isString() && defaultSrc.length) {
                    element.attr('src', defaultSrc);
                    element.error(function () {
                        if (attrs.imageLoadError) {
                            $timeout(function () {
                                $parse(attrs.imageLoadError)($scope);
                            });
                        }
                        element.attr('src', defaultSrc);
                    });
                    element.load(function () {
                        if (attrs.imageLoaded && element.attr('src') !== defaultSrc) {
                            $timeout(function () {
                                $parse(attrs.imageLoaded)($scope);
                            });
                        }
                    });
                }
            }
        };
    }]);
}());